$(document).on('turbolinks:load', function () {
  let selectedCompetitorId = null;

  $(document).on('click', '.competitor-name-selector', function (e) {
    e.preventDefault();
    const modal = $('#competitor-selector-modal');
    if (modal.length) {
      modal.modal('show');
    }
  });

  $(document).on('shown.bs.modal', '#competitor-selector-modal', function () {
    const modal = $(this);
    const searchInput = modal.find('#competitor-search-input');
    if (searchInput.length) {
      searchInput.val('').focus();
    }

    const competitorItems = modal.find('.competitor-item');
    competitorItems.show().removeClass('border-primary');

    const chooseBtn = modal.find('#choose-competitor-btn');
    if (chooseBtn.length) {
      chooseBtn.prop('disabled', true);
    }

    selectedCompetitorId = null;
  });

  $(document).on('input keyup', '#competitor-search-input', function () {
    const searchTerm = $(this).val().toLowerCase();
    const modal = $('#competitor-selector-modal');
    const items = modal.find('.competitor-item');

    if (items.length === 0) return;

    items.each(function () {
      const $item = $(this);
      const nameAttr = $item.attr('data-competitor-name');
      if (!nameAttr) return;

      const name = nameAttr.toLowerCase();
      if (name.includes(searchTerm)) {
        $item.removeClass('d-none').addClass('d-flex');
      } else {
        $item.addClass('d-none').removeClass('d-flex');
      }
    });
  });

  $(document).on('click', '.competitor-item', function () {
    const $item = $(this);
    const modal = $('#competitor-selector-modal');
    modal.find('.competitor-item').removeClass('border-primary');
    $item.addClass('border-primary');
    selectedCompetitorId = $item.attr('data-competitor-id');
    modal.find('#choose-competitor-btn').prop('disabled', false);
  });

  $(document).on('click', '#choose-competitor-btn', function () {
    if (!selectedCompetitorId) return;

    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const pathParts = url.pathname.split('/').filter(function (p) {
      return p;
    });
    const leaguesIndex = pathParts.indexOf('leagues');

    if (leaguesIndex === -1) return;

    const leagueId = pathParts[leaguesIndex + 1];
    const basePath = '/public/hotsites/leagues/' + leagueId;
    const newUrl = basePath + '/competitors/' + selectedCompetitorId;
    window.location.href = newUrl;
  });
});
